module.exports = __webpack_public_path__ + "static/media/hotel.d1038eb4.svg";